exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExtraInformationModal-module__content___kNkIG{display:grid;gap:24px;gap:32px}.ExtraInformationModal-module__content___kNkIG h3{font-size:32px;color:#333!important}.ExtraInformationModal-module__content___kNkIG p{color:#333}", ""]);

// exports
exports.locals = {
	"content": "ExtraInformationModal-module__content___kNkIG"
};